import React, { useState, useRef, useEffect } from 'react';
import '../SearchableDropdown.css';

const SearchableDropdown = ({ 
  options, 
  onSelect, 
  value, 
  label,
  className 
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState(value || '');
  const dropdownRef = useRef(null);

  // 🔄 Synchronizuj wartość z zewnątrz
  useEffect(() => {
    setSearchTerm(value || '');
  }, [value]);

  // 🔍 Filtracja opcji
  const filteredOptions = options.filter(option =>
    option.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // 📦 Zamknij dropdown po kliknięciu poza nim
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // ✅ Wybór opcji z listy
  const handleSelect = (option) => {
    setSearchTerm(option);
    setIsOpen(false);
    if (onSelect) onSelect(option);
  };

  // ✅ Obsługa zmian w inpucie (ważne!)
  const handleInputChange = (e) => {
    const val = e.target.value;
    setSearchTerm(val);
    setIsOpen(true);

    // 🔹 Jeśli użytkownik skasuje cały tekst — przekaż pustą wartość
    if (val.trim() === '') {
      onSelect && onSelect('');
    }
  };

  return (
    <div ref={dropdownRef} className={`searchable-dropdown ${className || ''}`}>
      {label && <small className="form-label">{label}</small>}

      <div className="input-wrapper" style={{ position: 'relative' }}>
        <input
          type="text"
          className="form-control"
          placeholder="Wybierz lub wpisz język"
          value={searchTerm}
          onChange={handleInputChange}
          onClick={() => setIsOpen(true)}
        />

        {/* Strzałka dropdowna */}
        <span
          onClick={() => setIsOpen(!isOpen)}
          onMouseEnter={(e) => (e.target.style.cursor = 'pointer')}
          style={{
            position: 'absolute',
            right: '12px',
            top: '50%',
            width: '6px',
            height: '6px',
            borderRight: '2px solid #555',
            borderBottom: '2px solid #555',
            transform: 'translateY(-50%) rotate(45deg)',
          }}
        ></span>
      </div>

      {isOpen && filteredOptions.length > 0 && (
        <ul className="dropdown-list">
          {filteredOptions.map((option, index) => (
            <li
              key={index}
              className="dropdown-item"
              onClick={() => handleSelect(option)}
            >
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SearchableDropdown;
